/*global
    toString, module
*/
(function (root, factory) {
    'use strict';

    if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.aap = root.aap || {};
        root.aap.is = factory();
    }
}(this, function () {

    'use strict';

    return function (obj) {
        var a = function (check) {
            return !!(
                (obj !== undefined && obj !== null && obj === obj && obj.constructor === check && check) ||
                (check && toString.call(obj).indexOf(check.name) > -1 && obj instanceof check) ||
                (!check && check === obj)
            );
        };

        var valid = function (check, val) {

            var rules = {
                    email: /^[a-zA-Z0-9.!#$%&’*+\/=?\^_`{|}~\-]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]+)*$/,
                    url: /^\s*https?:\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?\s*$/
                };

            if(check === 'regex' && val) {
                return val.test(obj);
            }

            return rules[check].test(obj);
        };

        var empty = function() {
            if(obj === null ) {
                return true;
            }
            return !obj.replace(/^\s+/g, '').length;
        };

        /*
         * Usage:
         * aap.is([1,2,3,4]).an(Array); //true
         * aap.is('Hello').an(Object); //false
         * aap.is('Hello').a(String); //true
         * aap.is($('a')[0]).an(Element); //true
         *
         * aap.is('ranjan@adoptapet.com').valid('email'); //true
         * aap.is('www.adoptapet.com').valid('url'); //false
         * aap.is('1').valid('regex', /^-?\d*\.?\d*$/); //true
         *
         * aap.is('').empty() //true
         */

        return {
            a: a,
            an: a,
            valid: valid,
            empty: empty
        };
    };
}));
